import React from "react";

import styles from "./errorMessage.module.css";
import ErroIcon from "../../../assets/error-icon.svg";

const ErrorMessage = ({ message }) => {
  return (
    <>
      {message && (
        <div className={styles.errorMessage}>
          <img src={ErroIcon} alt="Erro" className="error-icon" />
          <p>{message}</p>
        </div>
      )}
    </>
  );
};

export default ErrorMessage;
